import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.412 5.457c.34.34.34.89 0 1.23l-8.73 8.73-4.094-4.092a.87.87 0 0 1 1.23-1.23l2.863 2.863 7.501-7.5a.87.87 0 0 1 1.23 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }